import {SODeleteRelationshipAttributePermissionRule} from '../../core/relationship-attribute-permission-rule/so-delete-relationship-attribute-permission-rule';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteRelationshipAttributePermissionRule extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteRelationshipAttributePermissionRule;
}